"use client";

import { ArrowRight } from "lucide-react";
import { LinkWithChannel } from "@/ui/atoms/link-with-channel";

interface MegaFeatureCardProps {
	eyebrow: string;
	title: string;
	description: string;
	cta: string;
	href: string;
}

export function MegaFeatureCard({ eyebrow, title, description, cta, href }: MegaFeatureCardProps) {
	return (
		<LinkWithChannel
			href={href}
			className="group relative flex flex-col gap-3.5 overflow-hidden rounded-[18px] bg-gradient-to-br from-foreground via-foreground to-primary p-[22px] text-background no-underline"
		>
			{/* Soft radial highlight */}
			<span
				aria-hidden
				className="pointer-events-none absolute -right-[25%] -top-[30%] h-[220px] w-[220px] rounded-full bg-[radial-gradient(circle,rgba(166,191,222,0.35)_0%,transparent_65%)]"
			/>
			<span className="text-background/70 font-mono text-[10px] font-semibold uppercase tracking-[0.14em]">
				{eyebrow}
			</span>
			<h4 className="text-[22px] font-bold leading-[1.15] tracking-[-0.015em]">{title}</h4>
			<p className="text-background/80 text-[13px] leading-[1.5]">{description}</p>
			<span className="group-hover:bg-background/95 mt-auto inline-flex items-center gap-1.5 self-start rounded-full bg-background px-3.5 py-2 text-[12.5px] font-semibold text-foreground transition-colors">
				{cta}
				<ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5" />
			</span>
		</LinkWithChannel>
	);
}
